import React, { useState } from 'react';
import styles from './toggleOption.module.scss';

type ToggleValue = 'counterparties' | 'transactionLimits';

interface ToggleSwitchProps {
  onToggle?: (value: ToggleValue) => void;
  defaultValue?: ToggleValue;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  onToggle,
  defaultValue = 'counterparties',
}) => {
  const [active, setActive] = useState<ToggleValue>(defaultValue);

  const handleToggle = (value: ToggleValue) => {
    setActive(value);
    onToggle?.(value);
  };

  return (
    <div className={styles.toggleContainer}>
      <span className={styles.toggleLabel}>Режим работы</span>

      <div
        className={styles.toggleSwitch}
        onClick={() =>
          handleToggle(active === 'counterparties' ? 'transactionLimits' : 'counterparties')
        }
      >
        {/* Sliding indicator */}
        <div
          className={`${styles.toggleSlider} ${
            active === 'transactionLimits' ? styles.active : ''
          }`}
        />

        {/* Left Option */}
        <div
          className={`${styles.toggleOption} ${styles.left} ${
            active === 'counterparties' ? styles.active : ''
          }`}
          onClick={(e) => {
            e.stopPropagation();
            handleToggle('counterparties');
          }}
        >
          Контрагенты
        </div>

        {/* Right Option */}
        <div
          className={`${styles.toggleOption} ${styles.right} ${
            active === 'transactionLimits' ? styles.active : ''
          }`}
          onClick={(e) => {
            e.stopPropagation();
            handleToggle('transactionLimits');
          }}
        >
          Лимиты транзакций
        </div>
      </div>
    </div>
  );
};

export default ToggleSwitch;